import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/loose_setting/high.svg")